import { VARIABLE_CONSTANTS, VariableCrudManagerService } from "@wms/variables";
import { ServiceFactoryService, DataModelDesignManagerService, ProjectService } from "@wms/services";
import { filter, forEach, orderBy } from "lodash-es";
import { BaseVariableService } from "@wms/variables";

export class DatabaseVariableCreation {
    operationIdToOperationMap: any = {};
    constructor(private serviceFactory: ServiceFactoryService, private varManagerService: VariableCrudManagerService, private variableService: BaseVariableService, private dataModelDesignManagerService: DataModelDesignManagerService, private projectService: ProjectService) {
    }

    getVariableDependencies() {
        /*get the list of services available and append the options for service property*/
        (this.serviceFactory.getServicesWithType() as Promise<any>).then((services) => {
            let dataServicesObj: any = {},
                selectedVariable = this.varManagerService.initVariableObj;
            services.sort((prevItem: any, currentItem: any) => prevItem.name.localeCompare(currentItem.name));
            /* iterating over mixed services returned to collect names of DataServices */
            forEach(services, (serviceObj) => {
                if (serviceObj.type === VARIABLE_CONSTANTS.SERVICE_TYPE_DATA) {
                    dataServicesObj[serviceObj.name] = serviceObj.name;
                }
            });
            /* assign the data services array to the options of live source property */
            selectedVariable.propertyObj.liveSource.options = dataServicesObj;
        });
    }

    /**
     * This function creates a service variable for query and procedure API's
     * @param target, This is the API type that has been selected
     */
    createQueryProcedureServiceVariable(target: any) {
        let selectedVariable = this.varManagerService.initVariableObj;
        selectedVariable.propertyObj.table.hide = true;
        selectedVariable.propertyObj.operation.hide = true;
        this.varManagerService.selectedVariableCategory = 'wm.ServiceVariable';
        this.varManagerService.createVariable(this.varManagerService.selectedVariableCategory, {
        service: selectedVariable.values.liveSource,
            _operationType: target
        });
    }

    getDefaultOptions() {
        return {
            'read': {'name': 'read', 'type': 'CRUD Operations'},
            'create': {'name': 'create', 'type': 'CRUD Operations'},
            'update': {'name': 'update', 'type': 'CRUD Operations'},
            'delete': {'name': 'delete', 'type': 'CRUD Operations'}
        };
    }

    /**
     * Hide fields of the changedElement
     * @param changedElement, the element that has been changed
     */
    hideFieldsOnChange(changedElement: any) {
        let selectedVariable = this.varManagerService.initVariableObj, 
        propertyObj          = selectedVariable.propertyObj;
        switch(changedElement) {
            case 'liveSourceCleared': {
                propertyObj.target.hide = true;
                propertyObj.table.hide = true;
                propertyObj.operation.hide = true;
                break;
            }
            case 'liveSourceChanged': {
                propertyObj.table.hide = true;
                propertyObj.operation.hide = true;
            }
        }
    }

    /**
     * Clear fields of the changedElement
     * @param changedElement, the element that has been changed
     */
    clearFieldsOnChange(changedElement: any) {
        let selectedVariable = this.varManagerService.initVariableObj, 
        propertyObj = selectedVariable.propertyObj;

        switch (changedElement) {
            case 'liveSource': {
                if(propertyObj.table?.modelObj.target) {
                    propertyObj.table.modelObj.target = "";
                }
                if(propertyObj.table?.modelObj.table) {
                    propertyObj.table.modelObj.table = "";
                }
                if(propertyObj.operation.modelObj.operation) {
                    propertyObj.operation.modelObj.operation = "";
                }
                // if(this.variableService.selectedVariable) {
                //     $scope.wmvariables.selectedVariable = undefined;
                // }
                break;
            }
            case 'table': {
                if (propertyObj.operation.modelObj.operation) {
                    propertyObj.operation.modelObj.operation = "";
                }
                // if($scope.wmvariables.selectedVariable) {
                //     $scope.wmvariables.selectedVariable = undefined;
                // }
            }
        }
    }

    onLiveSourceChange() {
        let selectedDatabase,
            selectedVariable = this.varManagerService.initVariableObj,
            propertyObj      = selectedVariable.propertyObj;
        selectedDatabase = selectedVariable.values['liveSource'];
        if (selectedDatabase) {
            propertyObj.target.hide = false;
            this.dataModelDesignManagerService.getDataModel(this.projectService.getProjectId(), selectedDatabase, false, (datamodel: any) => {
                let dataTables = datamodel.tables;
                let entityVsTableNameMap: any = {};
                propertyObj.table.options = {};
                selectedVariable.packageNameMap = {};
                dataTables = orderBy(dataTables, 'asc');
                //clear and hide table and operation field on change of database
                this.clearFieldsOnChange('liveSource');
                this.hideFieldsOnChange('liveSourceChanged');
                forEach(dataTables, (dataTable) => {
                    entityVsTableNameMap[dataTable.entityName] = dataTable.name;
                    propertyObj.table.options[dataTable.entityName] = dataTable.entityName;
                    selectedVariable.packageNameMap[dataTable.entityName] = dataTable.fullyQualifiedName;
                });
            });
        } else {
            //clear and hide table and operation field on change of database
            this.hideFieldsOnChange('liveSourceCleared');
            this.clearFieldsOnChange('liveSource');
        }
    }

    setServiceOperations(operations: any, selectedVariable: any) {
        let opKey;
        forEach(operations, (operation) => {
            //exclude all deprecated operations except current variable's operation
            if (operation.deprecated) {
                return;
            }
            opKey = operation.name;
            selectedVariable.propertyObj.operation.options[opKey] = operation.name;
            this.operationIdToOperationMap[opKey] = operation;
        });
    }

    onTableChange() {
        let selectedVariable    = this.varManagerService.initVariableObj,
            selectedService     = selectedVariable.values.liveSource,
            selectedTable       = selectedVariable.values.table,
            propertyObj         = selectedVariable.propertyObj,
            defaultOperations   = this.getDefaultOptions();
        if(selectedTable) {
            (this.serviceFactory.getServiceOperations(selectedService) as Promise<any>).then((operations) => {
                this.operationIdToOperationMap = {};
                propertyObj.operation.options = {};
                operations = filter(operations, { controller: selectedTable });
                this.setServiceOperations(operations, selectedVariable);
                this.clearFieldsOnChange('table');
            });
        }
        else{
            this.clearFieldsOnChange('table');
        }
    }

    __onPropertyChange(propName: any, newVal?: any) {
        let selectedVariable = this.varManagerService.initVariableObj,
            selectedVariablePropertyObject = selectedVariable.propertyObj,
            target = selectedVariable.values['target'];
        switch (propName) {
        case 'liveSource':
            if (target === 'query') {
                this.createQueryProcedureServiceVariable(target);
            }
            this.onLiveSourceChange();
            break;
        case 'target':
            if (this.variableService.selectedVariable) {
                if(this.varManagerService.initVariableObj.propertyObj['operation'].options) {
                    this.varManagerService.initVariableObj.propertyObj['operation'].options = "";
                }
            }
            if (target === 'table') {
                this.varManagerService.showPrimaryProps = false;
                selectedVariablePropertyObject.table.hide = false;
                selectedVariablePropertyObject.table.modelObj[selectedVariablePropertyObject.table.modelKey]="";
                selectedVariablePropertyObject.operation.hide = false;
                selectedVariablePropertyObject.operation.modelObj[selectedVariablePropertyObject.operation.modelKey]="";
                // $scope.toggleMessage(false);
            } else {
                selectedVariablePropertyObject.operation.modelObj[selectedVariablePropertyObject.operation.modelKey]="";
                this.createQueryProcedureServiceVariable(target);
                this.varManagerService.showPrimaryProps = true;
            }
            break;
        case 'table':
            this.onTableChange();
            break;
        case 'operation':
            let operation = selectedVariable.values.operation;
            if(operation) {
                this.varManagerService.showPrimaryProps = true;
                let defaultOperations: any = this.getDefaultOptions();
                if (defaultOperations[operation]) {
                    this.varManagerService.selectedVariableCategory = 'wm.LiveVariable';
                    this.varManagerService.createVariable(this.varManagerService.selectedVariableCategory, selectedVariable.values);
                } else {
                    this.varManagerService.selectedVariableCategory = 'wm.ServiceVariable';
                    this.varManagerService.createVariable(this.varManagerService.selectedVariableCategory, {
                        service: selectedVariable.values.liveSource,
                        operation: operation,
                        controller: this.operationIdToOperationMap[operation].controller,
                        _operationType: 'databaseapi'
                    });
                }
            }
            else{
                // $scope.disableDialogActions = true;
            }
            break;
        }
    }
}
